module.exports = __webpack_public_path__ + "static/chara-27b268c6e67882337f4a61819a7cfbf4.png";